var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRandb = function SvgRandb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.607 19.718v-2.02c0-.067.006-.129.011-.19a2.28 2.28 0 0 1-1.035.241 2.372 2.372 0 0 1-2.368-2.368 2.367 2.367 0 0 1 2.368-2.362 2.362 2.362 0 0 1 2.363 2.362c0 .236-.034.461-.101.675l4.618-1.924c.084-.039.174-.067.264-.084-.63-3.37-3.589-5.923-7.138-5.923a7.27 7.27 0 0 0-7.262 7.262 7.265 7.265 0 0 0 6.289 7.194 2.687 2.687 0 0 1 1.991-2.863Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.59 14.818a.56.56 0 0 0-.563.563.565.565 0 0 0 1.131 0 .564.564 0 0 0-.563-.563h-.005ZM23.422 15.223a.562.562 0 0 0-.528-.05l-4.815 2.007a.562.562 0 0 0-.346.52v3.111a1.56 1.56 0 0 0-.439-.069c-.862 0-1.564.705-1.564 1.57a1.565 1.565 0 1 0 3.128-.077v-2.26l3.69-1.534v1.32a1.54 1.54 0 0 0-.439-.07 1.566 1.566 0 0 0 0 3.133c.854 0 1.555-.7 1.564-1.559v-5.574a.563.563 0 0 0-.25-.468Z",
    fill: "#fff"
  })));
};
export default SvgRandb;